import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookSimple"><Path d="M6.5 21.5H19.5V2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V19.5M6.5 21.5C5.39543 21.5 4.5 20.6046 4.5 19.5M6.5 21.5H10M4.5 19.5C4.5 18.3954 5.39543 17.5 6.5 17.5H19.5V12.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconBookSimple;
